import ReactDOM from "react-dom";

export default function PortalForModal(props: any) {
  return ReactDOM.createPortal(
    props.children,
    document.getElementById("portalForModal") as HTMLElement,
  );
}
